import { Component, OnDestroy, OnInit } from '@angular/core';
import { UtilitiesService } from '@services/utilities.service';
import { TableColumn } from '@shared/interface/table.interface';
import { BehaviorSubject } from 'rxjs';
import { API } from '@config/constants/api.constant';
import { RolePrivilegeService } from '@services/role-privilege.service';
import { getDistributorTableColumns } from '../../../distributor.data';
import { DistributorService } from '../../../distributor.service';

@Component({
  selector: 'app-verification',
  styleUrls: ['./verification.component.scss'],
  template: `
    <app-card-table-list
      [url]="API.LIST_DISTRIBUTOR_PENDING_VERIFICATION"
      [tableColumns]="tableColumns"
      [privilegeDetail]="privilegeDetailPending"
      [actionPathDetail]="distributorService.BasePathDistributorDetail + '/pending/verification/'"
      (totalCount)="onTotalCount($event)"
    />
  `,
})
export class VerificationComponent implements OnInit, OnDestroy {
  tableColumns: TableColumn[] = getDistributorTableColumns('pending');
  privilegeDetailPending: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public static totalCount = new BehaviorSubject(0);

  constructor(public utilities: UtilitiesService, private rolePrivilegeService: RolePrivilegeService, public distributorService: DistributorService) {}

  ngOnInit() {
    this.privilegeDetailPending.next(this.rolePrivilegeService.checkPrivilege('DISTRIBUTOR', 'LIST_MENUNGGU', 'TAB_LIST_VERIFICATION_REQUEST', 'CTA_VIEW_DETAIL'));
    this.tableColumns = this.utilities.privilegeTableColumns(this.privilegeDetailPending.value, this.tableColumns);
  }

  onTotalCount = (e: number) => VerificationComponent.totalCount.next(e);

  ngOnDestroy() {}

  protected readonly API = API;
}
